<template>
<div class="info-container" v-if="tableData.length > 0">
  <div class="level">
    <h4 class="title">
      <template v-if="type == 'main'">Company</template>
      <template v-if="type == 'person'">Persons</template>
      <template v-if="type == 'holding'">Holding Companies</template>
    </h4>
  </div>

    <b-table
      v-if="tableData"
      :data="tableData"
      :id="`table_${type}`"
      narrowed
      bordered
      striped
      hoverable
      :row-class="row => row.sharesPercentage && row.sharesPercentage < $store.state.shareThreshold && 'has-text-grey-light has-background-white-ter'"
      :default-sort="['sharesPercentage', 'desc']"
    >

      <template slot-scope="props">
        <b-table-column field="name" label="Name" sortable>
          <kyc-details-table-cell
            :value="props.row.name"
            @value-changed="updateName(props.row.order, $event)"
          >
            <b-tooltip label="Delete" type="is-dark" position="is-bottom">
              <a href="" @click.prevent="$emit('delete-entity', props.row.name)"
                v-if="$auth.check(['admin', 'superadmin'])"
              >
                <b-icon icon="delete" size="is-small"/>
              </a>
            </b-tooltip>
          </kyc-details-table-cell>
        </b-table-column>

        <b-table-column field="role" label="Role (Position)" v-if="type === 'person'" sortable>
          <template v-for="(role, idx) in props.row.role">
            <div :key="'role_'+idx">
              {{ toTitleCase(role) }}
              <template v-if="role === 'representative'">{{ props.row.position ? `(${toTitleCase(props.row.position)})` : '' }}</template>
              <!-- <template v-if="role === 'shareholder' && props.row.sharesPercentage !== null">{{ `(${props.row.sharesPercentage}%)` }}</template> -->
              <!-- <b-field>
                <b-input v-model="props.row.role[idx]" expanded/>
                <b-tooltip label="Save" type="is-dark" position="is-bottom">
                  <a @click.prevent="updateValue" title="Save">
                    <b-icon icon="content-save"></b-icon>
                  </a>
                </b-tooltip>
                <b-tooltip label="Cancel" type="is-dark" position="is-bottom">
                  <a @click.prevent="isEdited = false" title="Cancel">
                    <b-icon icon="cancel"></b-icon>
                  </a>
                </b-tooltip>
               </b-field> -->
               <a href="" @click.prevent="$emit('delete-role', props.row.name, idx)">
                <b-icon icon="delete" size="is-small"/>
               </a>
            </div>
          </template>
        </b-table-column>

        <b-table-column field="parent"
          label="Relevant company"
          v-if="type != 'main'"
          sortable
        >
          <template v-for="(parent, idx) in props.row.parent">
            <div :key="'parent_'+idx">
            {{parent}}
            </div>
          </template>
        </b-table-column>

        <b-table-column field="sharesNumber"
          label="Shares"
          v-if="type != 'main' && showShares"
          sortable
        >
          <kyc-details-table-cell
            :value="props.row.sharesNumber"
            @value-changed="updateSharesNumber(props.row.name, props.row.parent[0], $event)"
          />
        </b-table-column>

        <b-table-column field="sharesPercentage"
          label="Shares %"
          v-if="type != 'main' && showShares"
          sortable
        >
          {{ props.row.sharesPercentage ? props.row.sharesPercentage + '%' : '' }}
        </b-table-column>

        <b-table-column
          v-for="(col, idx) in docColumns"
          :label="col.docDescShort"
          :field="col + idx"
          :key="col.docId"
          :class="['requirement-cell', getCellClass(props.row.requiredDocs[col.docId])]"
        >
          <b-dropdown hoverable position="is-bottom-left"
            v-model="props.row.requiredDocs[col.docId]"
            @click.native="onStatusChange(props.row, type, col.docId)"
          >
            <svg-mark slot="trigger"
              v-if="props.row.requiredDocs.hasOwnProperty(col.docId)"
              :value="props.row.requiredDocs[col.docId]"
              @click.native="cellChangeStatus(props.row, type, col.docId)"
            />

            <b-dropdown-item :value="0">
              <div class="media">
                <svg-mark :value="0" class="media-left"/>
                <div class="media-content">
                  <h3>Not received</h3>
                  <small>document not received</small>
                </div>
              </div>
            </b-dropdown-item>

            <b-dropdown-item :value="10">
              <div class="media">
                <svg-mark :value="10" class="media-left"/>
                <div class="media-content">
                  <h3>Copy received</h3>
                  <small>copy of document received</small>
                </div>
              </div>
            </b-dropdown-item>

            <b-dropdown-item :value="20">
              <div class="media">
                <svg-mark :value="20" class="media-left"/>
                <div class="media-content">
                  <h3>Original received</h3>
                  <small>original or certified true copy of document received</small>
                </div>
              </div>
            </b-dropdown-item>

            <hr class="dropdown-divider">

            <b-dropdown-item :value="99">
              <div class="media">
                <svg-mark :value="99" class="media-left"/>
                <div class="media-content">
                  <h3>Not required</h3>
                  <small>share is less than 25%</small>
                </div>
              </div>
            </b-dropdown-item>
          </b-dropdown>
        </b-table-column>
      </template>
    </b-table>

</div>
</template>

<script>
import changeCase from 'change-case'

import SvgMark from '@/components/KycDetailsSvgMark'
import KycDetailsTableCell from '@/components/KycDetailsTableCell'

export default {
  name: 'KycDetailsTable',
  components: {
    SvgMark,
    KycDetailsTableCell
  },
  props: ['tableData', 'type', 'showShares'],
  data () {
    return {
      editNames: false,
      cellStates: [
        {
          value: 0,
          class: 'requirement-cell--required',
          desc: 'document not received'
        },
        {
          value: 10,
          class: 'requirement-cell--partial',
          desc: 'copy of document received'
        },
        {
          value: 20,
          class: 'requirement-cell--completed',
          desc: 'original or certified true copy of document received'
        }
      ]
    }
  },
  computed: {
    docColumns () {
      if (this.tableData && this.tableData.length > 0) {
        let columns = this.getColumnsUnique(this.tableData, 'requiredDocs')
        if (this.$store.state.docTypesDesc) {
          columns = columns.map(this.getDocTypeDescByKey)
        }
        return columns
      }
    }
  },
  methods: {
    getColumnsUnique (objects, key) {
      const allKeys = objects.map(obj => {
        if (obj.hasOwnProperty(key)) {
          return Object.keys(obj[key])
        }
      })
      return [...new Set(...allKeys)]
    },
    getDocTypeDescByKey (key) {
      if (this.$store.state.docTypesDesc) {
        const filtered = this.$store.state.docTypesDesc.filter(doc => {
          return doc.docId === key
        })
        if (filtered && filtered.length > 0) {
          return filtered[0]
        }
      }
      return key
    },
    onStatusChange (rowObj, entity, docId) {
      this.$emit('cell-changed',
        entity,
        rowObj.order,
        docId,
        rowObj.requiredDocs[docId]
      )
    },
    cellChangeStatus (rowObj, entity, docId) {
      if (rowObj.requiredDocs.hasOwnProperty(docId)) {
        const nextState = this.getNextState(rowObj.requiredDocs[docId])
        if (!nextState) return
        rowObj.requiredDocs[docId] = nextState.value
        this.$emit('cell-changed', entity, rowObj.order, docId, nextState.value)
      }
    },
    getNextState (currentValue) {
      let stateIdx = this.cellStates.findIndex(state => state.value === currentValue)
      if (stateIdx === -1) stateIdx = this.cellStates.length - 1
      if (stateIdx >= this.cellStates.length - 1) stateIdx = -1
      const nextState = this.cellStates[stateIdx + 1]
      return nextState
    },
    getStateDesc (value) {
      let stateIdx = this.cellStates.findIndex(state => state.value === value)
      if (stateIdx === -1) return
      const state = this.cellStates[stateIdx]
      return state.desc
    },
    updateName (index, newName) {
      const oldName = this.tableData[index].name

      this.$emit('update-tree', {
        type: this.tableData[index].role,
        oldName,
        newName
      })

      this.$set(this.tableData[index], 'name', newName)

      // request to update db
      const entityType = this.type
      // const newListData = this.data
      this.$emit('names-updated', { entityType, oldName, newName })
      this.editNames = false
    },
    updateSharesNumber (name, parentName, newValue) {
      const entityType = this.type
      this.$emit('shares-num-updated', {
        entityType,
        name,
        parentName,
        newValue
      })
    },
    getCellClass (value) {
      const state = this.cellStates.find(state => {
        return state.value === value
      })
      if (state) return state.class
    },
    toTitleCase (text) {
      return changeCase.titleCase(text)
    }
  }
}
</script>

<style scoped>

.info-container {
  margin-bottom: 2em;
}

.requirement-cell {
  cursor: pointer;
  text-align: center;
  width: 4em;
}

.table td.requirement-cell {
  border-right-width: 1px;
  border-left-width: 1px;
}

.table td.requirement-cell:hover {
  background-color: #f5f5f5;
}

</style>
